'use client';

import React, { useState, useCallback } from 'react';
import AppLayout from '@/components/AppLayout';
import VisualLabHeader from './components/VisualLabHeader';
import VisualLabPromptPanel from './components/VisualLabPromptPanel';
import VisualLabGallery from './components/VisualLabGallery';
import { ErrorBoundary } from '@/components/ui/ErrorBoundary';

interface GeneratedImage {
  id: string;
  prompt: string;
  style: string;
  ratio: string;
  platform: string;
  color: string;
  b64_json?: string;
  created: string;
  status: 'bereit' | 'generiert' | 'fehlgeschlagen';
}

export default function VisualLabPage() {
  const [generating, setGenerating] = useState(false);
  const [newImages, setNewImages] = useState<GeneratedImage[] | undefined>(undefined);

  const handleImagesGenerated = useCallback((images: GeneratedImage[]) => {
    setNewImages(images);
  }, []);

  return (
    <AppLayout currentPath="/visual-lab">
      <div className="min-h-screen bg-background px-6 lg:px-8 xl:px-10 py-6 max-w-screen-2xl mx-auto">
        <VisualLabHeader />
        <div className="grid grid-cols-1 xl:grid-cols-3 gap-4 mt-6">
          <div>
            <ErrorBoundary
              title="Prompt-Panel Fehler"
              description="Das Prompt-Panel konnte nicht geladen werden. Bitte lade die Seite neu."
            >
              <VisualLabPromptPanel
                onGeneratingChange={setGenerating}
                onImagesGenerated={handleImagesGenerated}
              />
            </ErrorBoundary>
          </div>
          <div className="xl:col-span-2">
            <ErrorBoundary
              title="Galerie-Fehler"
              description="Die Bildgalerie konnte nicht geladen werden. Bitte lade die Seite neu."
            >
              <VisualLabGallery generating={generating} newImages={newImages} />
            </ErrorBoundary>
          </div>
        </div>
      </div>
    </AppLayout>
  );
}